// extracted by mini-css-extract-plugin
module.exports = {"highlight":"styles_highlight__9ZrhC","icon":"styles_icon__2VLl8","list":"styles_list__FeC67"};